
/* -- THIS IS A GENERATED FILE BY @relay -- */
import { ComponentRegistration } from '@relay/client';

export const registrations: ComponentRegistration[] = [
{
  name: 'VideoComponent',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/VideoComponent/VideoComponent.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'TabbedContent',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/TabbedContent/TabbedContent.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'StandstillCalculator',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/StandstillCalculator/StandstillCalculator.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'SectorsServicesList',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/SectorsServicesList/SectorsServicesList.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'SimpleCarousel',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/SimpleCarousel/SimpleCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'QuoteSection',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/QuoteSection/QuoteSection.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Quote',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Quote/Quote.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'PeopleCarousel',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/PeopleCarousel/PeopleCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'NoticeSearch',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/NoticeSearch/NoticeSearch.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'NavigationBlock',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/NavigationBlock/NavigationBlock.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ModalContactForm',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/ModalContactForm/ModalContactForm.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'LatestFeed',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/LatestFeed/LatestFeed.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ListCardCarousel',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/ListCardCarousel/ListCardCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'InsightsSection',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/InsightsSection/InsightsSection.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'InPageNavigation',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/InPageNavigation/InPageNavigation.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ImmersiveBanner',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/ImmersiveBanner/ImmersiveBanner.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ImageComponent',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/ImageComponent/ImageComponent.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'HeroCarouselBanner',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/HeroCarouselBanner/HeroCarouselBanner.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'FilteredCardListing',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/FilteredCardListing/FilteredCardListing.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'FeedFilters',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/FeedFilters/FeedFilters.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'BasicHeroBanner',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/BasicHeroBanner/BasicHeroBanner.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'AccordionList',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/AccordionList/AccordionList.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Breadcrumbs',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Breadcrumbs/Breadcrumbs.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Notification',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Global/Notification/Notification.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Header',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Global/Header/Header.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'FeedCard',
  import: (): Promise<any> => import('C:/agent/_work/13886/s/src/MillsReeve.Web/wwwroot/SiteFiles/next-gen/src/stories/Components/Cards/FeedCard/FeedCard.client'),
  config: {
  hydrate: 'in-view',
},
} 
];
  